export default __webpack_public_path__ + "1f4f9367b0495aebacbfa372f1cea2d2.png";